import { gql } from '@apollo/client';
import {
  CONTACT_INTERACTION_PARTICIPATING_ENTITY_CORE_FIELDS,
  CORE_ATTACHMENTS_FIELDS,
  CORE_CHAT_MESSAGES_FIELDS,
  CORE_NOTIFICATION_APPOINTMENT_FIELDS,
  CORE_NOTIFICATION_CONTACT_FIELDS,
  CORE_NOTIFICATION_TASK_FIELDS,
  CORE_NOTIFICATION_USER_FIELDS,
} from 'src/components/providers/apollo-provider-provider';

export const GET_NOTIFICATION_FEED_ITEMS = gql`
  ${CORE_ATTACHMENTS_FIELDS}
  ${CORE_CHAT_MESSAGES_FIELDS}
  ${CORE_NOTIFICATION_CONTACT_FIELDS}
  ${CORE_NOTIFICATION_USER_FIELDS}
  ${CONTACT_INTERACTION_PARTICIPATING_ENTITY_CORE_FIELDS}
  ${CORE_NOTIFICATION_TASK_FIELDS}
  ${CORE_NOTIFICATION_APPOINTMENT_FIELDS}
  query GetNotificationFeedItems(
    $where: NotificationFeedItemWhereInput
    $first: Int
    $after: String
    $before: String
    $last: Int
  ) {
    notificationFeedItems(
      first: $first
      after: $after
      before: $before
      last: $last
      where: $where
      orderBy: { occurredAt: DESC }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ... on NotificationFeedItem {
            id
            type
            status
            occurredAt
          }
          ... on NotificationFeedItemContactAssigned {
            contact {
              ...NotificationContactFragment
            }
            assignedBy {
              ...NotificationUserFragment
            }
          }
          ... on NotificationFeedItemContactUnassigned {
            contact {
              ...NotificationContactFragment
            }
            unassignedBy {
              ...NotificationUserFragment
            }
          }
          ... on NotificationFeedItemContactStatusChanged {
            contact {
              ...NotificationContactFragment
            }
            oldStatus {
              id
              name
            }
            newStatus {
              id
              name
            }
            originator {
              ...NotificationUserFragment
            }
          }
          ... on NotificationFeedItemContactUpdated {
            contact {
              ...NotificationContactFragment
            }
            originator {
              ...NotificationUserFragment
            }
            assignee {
              ...NotificationUserFragment
            }
          }
          ... on NotificationFeedItemScheduleAssigned {
            assignee {
              ...NotificationUserFragment
            }
            originator {
              ...NotificationUserFragment
            }
            schedule {
              ...NotificationScheduleFragment
            }
          }
          ... on NotificationFeedItemScheduleUpdated {
            assignee {
              ...NotificationUserFragment
            }
            originator {
              ...NotificationUserFragment
            }
            schedule {
              ...NotificationScheduleFragment
            }
          }

          ... on NotificationFeedItemScheduleCanceled {
            assignee {
              ...NotificationUserFragment
            }
            originator {
              ...NotificationUserFragment
            }
            schedule {
              ...NotificationScheduleFragment
            }
          }
          ... on NotificationFeedItemScheduleCreated {
            assignee {
              ...NotificationUserFragment
            }
            originator {
              ...NotificationUserFragment
            }
            schedule {
              ...NotificationScheduleFragment
            }
          }
          ... on NotificationFeedItemTaskAssigned {
            task {
              ...NotificationTaskFragment
            }
            originator {
              ...NotificationUserFragment
            }
            assignee {
              ...NotificationUserFragment
            }
          }
          ... on NotificationFeedItemTaskUpdated {
            task {
              ...NotificationTaskFragment
            }
            originator {
              ...NotificationUserFragment
            }
            assignee {
              ...NotificationUserFragment
            }
          }
          ... on NotificationFeedItemTaskCompleted {
            task {
              ...NotificationTaskFragment
            }
            originator {
              ...NotificationUserFragment
            }
            assignee {
              ...NotificationUserFragment
            }
          }
          ... on NotificationFeedItemTaskOverdue {
            task {
              ...NotificationTaskFragment
            }
          }
          ... on NotificationFeedItemTaskReminder {
            task {
              ...NotificationTaskFragment
              dueAt
              reminderAt
            }
            assignee {
              ...NotificationUserFragment
            }
          }
          ... on NotificationFeedItemCallMissed {
            contact {
              ...NotificationContactFragment
            }
            contactInteractionPhoneCall {
              id
              ... on ContactInteractionPhoneCall {
                id
                recording {
                  url
                }
              }
            }
          }
          ... on NotificationFeedItemContactInteractionNew {
            contact {
              ...NotificationContactFragment
            }
            contactAssignee {
              ...NotificationUserFragment
            }
            contactStage {
              name
            }
            contactInteraction {
              ... on ContactInteraction {
                id
                createdAt
                registrationType
                participatingEntity {
                  ...ContactInteractionParticipatingEntityFragment
                }
              }
              ... on ContactInteractionWithDirection {
                direction
              }
              ... on ContactInteractionPhoneCall {
                dialStatus
                callDetail {
                  inboundLastStep
                }
                recording {
                  url
                }
              }
              ... on ContactInteractionWithAttachments {
                ...ContactInteractionAttachmentsFragment
              }
              ... on ContactInteractionChatMessage {
                ...ContactInteractionChatMessagesFragment
              }
              ... on ContactInteractionFacebookAd {
                fields {
                  key
                  label
                  value
                }
              }
              ... on ContactInteractionEmail {
                subject
                bodyText
                bodyHtml
              }
            }
          }
          ... on NotificationFeedItemConversationNoteNew {
            contact {
              ...NotificationContactFragment
            }
            originator {
              ...NotificationUserFragment
            }
            conversationNote {
              id
              text
              conversation {
                id
              }
            }
          }
          ... on NotificationFeedItemConversationNoteMention {
            contact {
              ...NotificationContactFragment
            }
            originator {
              ...NotificationUserFragment
            }
            conversationNote {
              id
              text
              conversation {
                id
              }
            }
          }
          ... on NotificationFeedItemReportReady {
            report {
              id
              title
            }
            downloadUrl
          }
          ... on NotificationFeedItemFacebookPageAccessTokenExpired {
            company {
              id
            }
            pageName
          }
          ... on NotificationFeedItemFacebookPageAccessTokenMissingPermissions {
            company {
              id
            }
            pageName
          }
          ... on NotificationFeedItemMessageDeliveryFailurePayment {
            contactInteraction {
              ... on ContactInteraction {
                id
                createdAt
                contact {
                  company {
                    id
                  }
                }
                registrationType
                participatingEntity {
                  ...ContactInteractionParticipatingEntityFragment
                }
              }
            }
            waba
          }
        }
      }
    }
  }
`;

export const NOTIFICATION_FEED_ITEMS_QUERY_PAGE_SIZE = 100;
